// extracted by mini-css-extract-plugin
export default {"vegetableQuestionContainer":"oFUqyFaEfIdaClej6Jlx","vegetableQuestion":"juwrmpBn8UWOk7gFOx1Z"};